export enum EActiveMobileBlock {
    product = 0,
    instrustion = 1,
    analogs = 2,
    feedback = 3
}